
// TailwindCSS用
// 連結する可能性があるため、末尾の空白は消さないこと
export const borderBottomStyle = 'border border-b-gray-500 ';
export const borderSideStyle = 'border-r-gray-500 ';
